export const getInputModePropsList = (type: BoardType, mode: BoardMode, moves: MoveProps[], openingRule: OpeningRule, inputMode: Ref<InputMode>): InputModeProps[] => {
  switch (type) {
    case 'game':
      return [
        {
          value: 'mark',
          icon: 'font_download',
          label: '記号',
          visible: getInputModeVisible(openingRule, moves, 'mark'),
          disabled: getInputModeDisabled(openingRule, moves, 'mark'),
          click: () => { inputMode.value = 'mark' }
        },
        {
          value: 'stone',
          icon: 'contrast',
          label: '交互',
          visible: getInputModeVisible(openingRule, moves, 'stone'),
          disabled: getInputModeDisabled(openingRule, moves, 'stone'),
          click: () => { inputMode.value = 'stone' }
        },
        {
          value: 'swap',
          icon: 'swap_horiz',
          label: '交換',
          visible: getInputModeVisible(openingRule, moves, 'swap'),
          disabled: getInputModeDisabled(openingRule, moves, 'swap'),
          click: () => { inputMode.value = 'swap' }
        }
      ]
    case 'puzzle':
      return [
        {
          value: 'mark',
          icon: 'font_download',
          label: '記号',
          visible: true,
          disabled: type === 'puzzle' && mode === 'edit',
          click: () => { inputMode.value = 'mark' }
        },
        {
          value: 'stone_black',
          icon: 'circle_black',
          label: '黒石',
          visible: type === 'puzzle' && mode === 'edit',
          disabled: mode === 'view',
          click: () => { inputMode.value = 'stone_black' }
        },
        {
          value: 'stone_white',
          icon: 'circle_white',
          label: '白石',
          visible: type === 'puzzle' && mode === 'edit',
          disabled: mode === 'view',
          click: () => { inputMode.value = 'stone_white' }
        },
        {
          value: 'stone',
          icon: 'contrast',
          label: '交互',
          visible: type === 'puzzle' && mode === 'view',
          disabled: type === 'puzzle' && mode === 'edit',
          click: () => { inputMode.value = 'stone' }
        },
        {
          value: 'stone_alternate',
          icon: 'contrast',
          label: '交互',
          visible: type === 'puzzle' && mode === 'edit',
          disabled: type === 'puzzle' && mode === 'view',
          click: () => { inputMode.value = 'stone_alternate' }
        }
      ]
    default:
      return []
  }
}
